import request from '@/utils/request'
import qs from 'qs'

export const getList = (params) => {
    return new request({
        url: './vulnerability/vulnerabilityInfos',
        method: 'get',
        params:params,
        headers:{
            type:'bug',
        }
    });
}
